const message = {
  ViewHelp: "查看帮助",
};

export default message;
